import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import {
  Container,
  Drawer,
  SwipeableDrawer,
  CssBaseline,
  List,
  Divider,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Logo from "./../../media/images/icons/pm_logo.png";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import clsx from "clsx";
import Session from "react-session-api";
import FormList from "../FormList";
import { Header } from "./AppBar";
import IconList from "./IconList";
import Global from "../../Global";

const drawerWidth = 200;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  link: {
    textDecoration: "none",
    color: theme.palette.text.primary,
  },
  sublink: {
    textDecoration: "none",
    color: theme.palette.text.primary,
    fontSize: 12,
  },
  subMenuStyle: {
    padding: 2,
    paddingLeft: 20,
  },
  // subMenuIcon: {
  //   paddingLeft: 10,
  //   paddingBottom: 25,
  //   height: 1,
  // },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    background: theme.palette.primary.gradient,
    ...theme.mixins.toolbar,
  },
  containerdiv: {
    marginLeft: 0,
  },
}));

export default function Navbar({ setIsLoggedIn }) {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  // const [isSubMenuOpen, setIsSubMenuOpen] = React.useState(false);
  const [openMenuName, setOpenMenuName] = React.useState("");

  const handleDrawerClose = () => {
    setOpen(false);
    open01 = false
    setOpenMenuName("");
  };
  var open01 = true;
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleLogOut = () => {
    Session.clear();
    setIsLoggedIn(false);
  };

  const handleMenuClick = (menuName, menutype) => {
   // debugger;
    // console.log(menuName);
    // setIsSubMenuOpen(!isSubMenuOpen);
    setOpenMenuName(menuName);
    if (menutype === "MainMenu" && (menuName === 'Dashboard' || menuName === "CRM - Sales" || menuName === "CRM - Service" || menuName === "Sales" || menuName === "Inventory" || menuName === "Masters")) {
      open01 = true;
    } else if (menutype === "Submenu") {
      open01 = false;
    }
    else {
      open01 = false;
    }
    console.log(menuName);


    // open01 = false;
  };

  const renderedNavList = Global.form_list.map((form) => {
    if (
      form.isMenuItem === 1 &&
      form.Authorization.includes(Session.get("UserType"))
    ) {
      const renderedSubMenuList = form.subMenu.map((sub) => {
        // ////debugger;
        if (
          sub.isMenuItem === 1 &&
          sub.Authorization.includes(Session.get("UserType"))
        ) {
          return (
            <Link key={sub.name} to={sub.path} className={classes.link}>
              <ListItem button className={classes.subMenuStyle} onClick={() => handleMenuClick(form.name, 'sabmenu')}>
                <ListItemIcon className={classes.subMenuStyle}>
                  <IconList name={sub.icon} />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.sublink }}
                  primary={sub.name}

                />
              </ListItem>
            </Link>
          );
        } else {
          return <></>;
        }
      });

      const renderNavCollapseIcon = () => {
        if (openMenuName === form.name && form.subMenu.length > 0) {
          return (
            <ListItemIcon style={{ marginLeft: "8rem" }}>
              <IconList name="ExpandLess" />
            </ListItemIcon>
          );
        } else if (openMenuName !== form.name && form.subMenu.length > 0) {
          return (
            <ListItemIcon style={{ marginLeft: "8rem" }}>
              <IconList name="ExpandMore" />
            </ListItemIcon>
          );
        } else {
          return <ListItemIcon />;
        }
      };
      if (form.subMenu.length > 0) {
        return (
          <div key={form.name} className={classes.link}>
            <ListItem
              name={form.name}
              button
              onClick={() => handleMenuClick(form.name, "MainMenu")}
            >
              <ListItemIcon>
                <IconList name={form.icon} />
              </ListItemIcon>
              <ListItemText primary={form.name} />
              {renderNavCollapseIcon()}
            </ListItem>
            <Collapse
              in={openMenuName === form.name ? true : false}
              timeout="auto"
              unmountOnExit
            >
              {renderedSubMenuList}
            </Collapse>
          </div>
        );
      } else {
        return (
          <Link key={form.name} to={form.path} className={classes.link}>
            <ListItem
              name={form.name}
              button
              onClick={() => handleMenuClick(form.name, "Submenu")}
            >
              <ListItemIcon>
                <IconList name={form.icon} />
              </ListItemIcon>
              <ListItemText primary={form.name} />
            </ListItem>
          </Link>
        );
      }
    } else {
      return <></>;
    }
  });

  const renderedRouteList = Global.form_list.map((form) => {
    return (
      <Route key={form.name} exact path={form.path}>
        <Container className={classes.containerdiv}>
          <main
            className={clsx(classes.content, {
              [classes.contentShift]: open,
            })}
          >
            <FormList name={form.name} />
          </main>
        </Container>
      </Route>
    );
  });

  const renderedSubRouteList = Global.form_list.map((form) => {
    return form.subMenu.map((sub) => {
      if (
        sub.isMenuItem === 1 &&
        sub.Authorization.includes(Session.get("UserType"))
      ) {
        return (
          <Route key={sub.name} exact path={sub.path}>
            <Container className={classes.containerdiv}>
              <main
                className={clsx(classes.content, {
                  [classes.contentShift]: open,
                })}
              >
                <FormList name={sub.name} />
              </main>
            </Container>
          </Route>
        );
      }
      // else {
      //   return <></>;
      // }
    });
  });
  const handlenewclick = (e) => {
   // debugger;
    if (open01 !== true) {
      setOpen(false)
    } else {
      setOpen(true)
    }
  }
  return (
    <Router>
      <div className={classes.root}>
        <CssBaseline />
        <Header
          IsNavOpen={open}
          handleDrawerOpen={handleDrawerOpen}
          handleLogOut={handleLogOut}
        />
        <SwipeableDrawer
          // variant="permanent"
          anchor="left"
          swipeAreaWidth={1}
          open={open}
          className={clsx(classes.drawer,
            //   {
            //   [classes.drawerOpen]: open,
            //   [classes.drawerClose]: !open,
            // }
          )}
          sx={{ width: "200px" }}

          onClick={(e) => handlenewclick(e)}
        // classes={{
        //   paper: clsx({
        //     [classes.drawerOpen]: open,
        //     [classes.drawerClose]: !open,
        //   }),
        // }}
        >
          <div className={classes.toolbar}>
            <img
              src={Logo}
              alt="LOGO"
              style={{ height: "60%", width: "60%" }}
            />
            <IconButton onClick={handleDrawerClose} style={{ color: "white" }}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon style={{ color: "white" }} />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </div>
          <Divider />
          <List>{renderedNavList}</List>
        </SwipeableDrawer>
        <Switch>
          {renderedRouteList}
          {renderedSubRouteList}
        </Switch>
      </div>
    </Router>
  );
}
